<template>
  <component :is="decoratorName">
    <SimpleSignin class="loginContainer"
                  :options="loginOptions"
                  @success="loginSuccess"></SimpleSignin>
  </component>
</template>

<script setup lang="ts">
import { CORE_ROUTER } from "@/core"
import { container } from "tsyringe"
import type { Router } from "vue-router"
// eslint-disable-next-line no-unused-vars
import ContainerPage from "./ContainerPage.vue"
import SimpleSignin from "./SimpleSignin.vue"

import { useLoginStore } from '../DefaultLoginPagePlugin'

const store = useLoginStore()
const decoratorName = store.$state.decoratorComponentName || 'container-page'

const loginOptions = {
  otherLogin: true
}

const router = container.resolve<Router>(CORE_ROUTER)

const loginSuccess = (data: string | number) => {
  if (data === 200) {
    router.push({ path: store.recordPath as string })
  }
}
</script>

<style scoped lang="less">
.form {
  width: 100%;

  .oauth2 {
    margin-top: 10px;
    display: flex;
    justify-content: start;
    align-items: center;

    .item {
      font-size: 24px;
      margin: 0 20px 0 20px;
    }
  }
}

.loginContainer {
  width: 100%;
  margin-top: 20px;
}
</style>
